// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__3mg2W","alignBottom":"form_alignBottom__3h7xs","disabled":"form_disabled__xhcLD","checkIsNotRobot":"form_checkIsNotRobot__3aLf7"};